import Cookies from 'js-cookie';

const TokenKey = 'Admin-Token';

const ExpiresInKey = 'Admin-Expires-In';

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getExpiresIn() {
  return Cookies.get(ExpiresInKey) || -1;
}

export function setExpiresIn(time) {
  return Cookies.set(ExpiresInKey, time);
}

export function removeExpiresIn() {
  return Cookies.remove(ExpiresInKey);
}

export function removeUserRegisterInfo() {
  let time1 = localStorage.getItem('courseHomeRefreshTime');
  let time2 = localStorage.getItem('myCourseRefreshTime');
  let time3 = localStorage.getItem('studyeHomeRefreshTime');
  localStorage.clear();
  localStorage.setItem('courseHomeRefreshTime', time1);
  localStorage.setItem('myCourseRefreshTime', time2);
  localStorage.setItem('studyeHomeRefreshTime', time3);
  removeToken();
  removeExpiresIn();
}



// WEBPACK FOOTER //
// ./src/utils/auth.js